<div class="pageheader">
  <div class="page-title">
    <h1>System Initialize Steps</h1>
    <div class="btn-group">
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'System Initialize Steps log'">
        <app-change-log-link-entity type="SystemInitStep"></app-change-log-link-entity>
        <app-change-log-link-entity type="PartnerResolver"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <label>System pre-disassembler</label>
    <app-developer-system-init-step-config systemInitStepType="PreDisassemble"></app-developer-system-init-step-config>
    <hr />
  </div>
  <div class="col-md-6">
    <label>System post-disassembler</label>
    <app-developer-system-init-step-config systemInitStepType="PostDisassemble"></app-developer-system-init-step-config>
    <hr />
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <label>Receiver partner resolvers</label>
    <app-developer-partner-fallback-resolver partnerResolverType="Receiver"></app-developer-partner-fallback-resolver>
    <hr />
  </div>
  <div class="col-md-6">
    <label>Sender partner resolvers</label>
    <app-developer-partner-fallback-resolver partnerResolverType="Sender"></app-developer-partner-fallback-resolver>
    <hr />
  </div>
</div>
